module.exports = __webpack_public_path__ + "img/chrome_fix.5834060a.png";